import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Profile from "../../assets/tamil.jpg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter
} from "react-icons/ai";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";

const About = () => {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="yellow"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hi, I'm <span className="yellow">Tamilselvan Rangasamy</span> from{" "}
              <span className="yellow">Coimbatore, Tamil Nadu</span>.
              <br />
              <br />

              I hold a Master's degree in <b className="yellow">Engineering Design</b> and
              have <b className="yellow">3+ years of hands-on experience</b> in web
              development.
              <br />
              <br />

              I specialize in <b className="yellow">React.js, Next.js, TypeScript,
                JavaScript, and the MERN stack</b>, with a focus on building responsive,
              scalable, and high-performance web applications.
              <br />
              <br />

              I have experience developing reusable components, integrating
              <b className="yellow"> REST APIs</b>, implementing SSR/SSG with Next.js,
              managing application state with Redux, and optimizing web performance and
              SEO.
              <br />
              <br />

              Currently, I work as a <b className="yellow">Technical Trainer at Amypo
                Technologies</b>, where I train students in <b className="yellow">Java,
                  Python, React.js, JavaScript, and frontend development</b> through hands-on
              coding, projects, and assessments.
              <br />
              <br />

              I enjoy learning new technologies, building innovative
              <b className="yellow"> web products</b>, and exploring opportunities in
              <b className="yellow"> Artificial Intelligence</b>.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={Profile} className="profile-image" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Please don't hesitate to reach out to me and <span className="yellow">connect.</span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/tamilselvanrangasamy/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="github"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/tamilselvantsr3?t=kFTaG-DFbThoJ4SaPtGU4A&s=09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="twitter"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/tamilselvan-rangasamy-8109141a0"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="linkedin"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://instagram.com/this_is_tsr?igshid=ZDdkNTZiNTM="
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="instagram"
                >
                  <FaInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );

}

export default About